angular.module('impactx.search').component('ixCountrySearchFilter', {
        bindings: {
            onChange: '&'
        },

        controller: 'CountrySearchFilterCtrl',
        templateUrl: 'modules/search/templates/country-search-filter.html'
    }
);